# frozen_string_literal: true

require_relative 'buy_company'

module Engine
  module Action
    class CorporateBuyCompany < BuyCompany
    end
  end
end
